import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=0caa426d&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa426d",
  null
  
)

export default component.exports